import { ChangeDetectionStrategy, Component, input, OnDestroy, OnInit, output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import { VehicleTransport } from '@/new-transport/_models/transport.model';

@Component({
	selector: 'app-vehicle-crew-row',
	standalone: true,
	imports: [FormsModule, MatFormFieldModule, ReactiveFormsModule, MatInputModule],
	templateUrl: './vehicle-crew-row.component.html',
	styleUrl: './vehicle-crew-row.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleCrewRowComponent implements OnInit, OnDestroy {
	readonly vehicle = input.required<VehicleTransport>();
	readonly newCrewEvent = output<number>();

	crewControl: FormControl;

	private readonly destroy$ = new Subject<void>();

	ngOnInit(): void {
		this.crewControl = new FormControl(this.vehicle().crew, [Validators.required, Validators.min(0)]);
		this.crewControl.valueChanges.pipe(debounceTime(400), takeUntil(this.destroy$)).subscribe((crew) => {
			if (crew > this.vehicle().capacity) {
				this.crewControl.setErrors({ crewExceedsCapacity: true });
			} else if (crew < 0) {
				this.crewControl.setErrors({ min: true });
			} else {
				this.newCrewEvent.emit(crew);
			}
		});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
